/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';

/**
 * 
 * @export
 * @interface ResponseListOrderType
 */
export interface ResponseListOrderType {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListOrderType
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListOrderType
     */
    message?: string;
    /**
     * 
     * @type {Array<OrderType>}
     * @memberof ResponseListOrderType
     */
    data?: Array<OrderType>;
}

/**
 * Check if a given object implements the ResponseListOrderType interface.
 */
export function instanceOfResponseListOrderType(value: object): value is ResponseListOrderType {
    return true;
}

export function ResponseListOrderTypeFromJSON(json: any): ResponseListOrderType {
    return ResponseListOrderTypeFromJSONTyped(json, false);
}

export function ResponseListOrderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListOrderType {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(OrderTypeFromJSON)),
    };
}

export function ResponseListOrderTypeToJSON(json: any): ResponseListOrderType {
    return ResponseListOrderTypeToJSONTyped(json, false);
}

export function ResponseListOrderTypeToJSONTyped(value?: ResponseListOrderType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(OrderTypeToJSON)),
    };
}

